/* @flow */
import createTheme from './createTheme';

export default createTheme();
